import { required, useTranslate } from 'ra-core';
import { AutocompleteArrayInput } from '../../components/admin/autocomplete-array-input';
import { BooleanInput } from '../../components/admin/boolean-input';
import { ReferenceArrayInput } from '../../components/admin/reference-array-input';
import { TextInput } from '../../components/admin/text-input';
import { ChecklistScheduleInput } from './ChecklistScheduleInput';
import { ChecklistTasksInput } from './Tasks/ChecklistTasksInput';

export function ChecklistFormInputs() {
  const translate = useTranslate();

  return (
    <div className="flex w-full max-w-[600px] flex-col gap-4">
      <TextInput source="title" validate={required()} />
      <ChecklistScheduleInput />

      <section className="flex flex-col gap-2">
        <h3 className="mt-2 text-lg font-semibold">
          {translate('moonstar.checklists.form.notifications')}
        </h3>
        <BooleanInput
          source="notifyUsersWhenChecklistStarted"
          helperText={false}
        />
        <BooleanInput
          source="notifyUsersWhenChecklistOverdue"
          helperText={false}
        />
      </section>

      <ChecklistTasksInput />

      <ReferenceArrayInput
        source="userGroupIds"
        reference="user-groups"
        perPage={999}
        sort={{ field: 'name', order: 'ASC' }}
      >
        <AutocompleteArrayInput
          optionText="name"
          filterToQuery={(query: string) => ({ name: query })}
          validate={required()}
        />
      </ReferenceArrayInput>
    </div>
  );
}
